import React from 'react';
import { Text } from 'components/text';
import { typography } from 'constants/styles';
import {} from './LockedCountryInputTooltipContent.types';
const LockedCountryInputTooltipContent = ({ content }) => (React.createElement(Text.Regular, { size: typography.TextSize.LEVEL_100 }, content));
export default LockedCountryInputTooltipContent;
